import CloseIcon from '@mui/icons-material/Close';
import { Modal, Box, Typography, Button } from '@mui/material';
import { colors } from 'src/styles/theme';

const modalStyle = {
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  top: '50%',
  left: '50%',
  cursor: 'pointer',
  transform: 'translate(-50%, -50%)',
  bgcolor: colors.white,
  border: `2px solid ${colors.primary.dark}`,
  borderRadius: '10px',
  boxShadow: 24,
  p: 4,
  maxHeight: '90%',
  overflow: 'auto',
  mb: '1rem',
  width: {
    lg: '40%',
    md: '65%',
    sm: '80%',
    xs: '95%',
  },
};

const SkipToLastStepModal = ({ closeModal, open, onContinue, closeable = false }) => {
  return (
    <Modal open={open} onClose={closeable ?? closeModal}>
      <Box sx={modalStyle}>
        {closeable ?? (
          <Box sx={{ display: 'flex', justifyContent: 'end', mb: '2rem' }}>
            <CloseIcon
              sx={{
                color: 'grey',
                cursor: 'pointer',
              }}
              onClick={closeModal}
            />
          </Box>
        )}

        <Typography variant="h6" sx={{ mb: '1rem', color: colors.warning.dark }}>
          Go to last step
        </Typography>
        <Typography variant="body1">
          Since your business is no longer in operation you can go to last step and review your
          filing information and submit{' '}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: '2rem' }}>
          <Button data-cy="refresh" color="primary" variant="contained" onClick={onContinue}>
            Continue
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default SkipToLastStepModal;
